/** The minimal shape a form must expose for this constraint to compare against: only `password` is read. */
type PasswordConfirmationShape = {
	readonly password: string;
};

/**
 * Generic over the minimal shape it reads, not over `NewPasswordFormData` itself, so the FormData
 * never has to import its own constraint back (`guides/forms.md` §1.1).
 */
function isPasswordConfirmed<T extends PasswordConfirmationShape>(value: string, formData: T): boolean {
	return value === formData.password;
}

export default isPasswordConfirmed;
